import React from 'react';
import './Login.scss';
import Api from "../../asstes/js/Api";
import Config from "../../asstes/js/Config";
import {
	inputFocusScroll,
	cancelBlockPlace,
	setStorageCache,
	successLogin,
	hideLogin, getMessageKey, getSessionCache
} from "../../asstes/js/Utils";
import {showToast} from "../../asstes/js/IntegratedProcessing";
import {getMsgCode, loginBocUserInFzs, userLogin} from "../../asstes/js/Rescource";

class Login extends React.Component {
	state = {
		imgBgLoad: false, // 背景图片加载
		imgTop: false,
		phoneNumber: '', // 手机号码
		messageCode: '', // 短信验证码
		captchaInfo: { // 图形验证码所需参数
			key: '',
			img: ''
		},
		captchaText: '', // 图形验证码
		seconds: 0,
		selectMouseIdx: getSessionCache('selectMouse') || Config.selectMouse // 当前选择的老鼠
	}

	UNSAFE_componentWillMount() {
		this.lock = true // 添加倒计时锁，性能优化
	}

	componentWillUnmount() {
		this.lock = false
	}

	handleInputChange = (event) => { // 输入事件
		const target = event.target;
		const value = target.value;
		const name = target.name;
		let isInputVal = ['phoneNumber', 'messageCode'].includes(name) ? String(value).replace(/[^\d]/g, '') : value
		this.setState({
			[name]: isInputVal
		})
		if (name === 'phoneNumber') { // 是手机号码
			if (/^[1][3456789][0-9]{9}$/.test(isInputVal)) {
				this.blurInput('phoneNumber')
			} else {
				this.setState({
					captchaInfo: {
						key: '',
						img: ''
					}
				})
			}
		} else if (name === 'messageCode' && isInputVal.length === 6) {
			this.blurInput('messageCode')
		} else if (name === 'captchaText' && isInputVal.length === 4) {
			this.blurInput('captchaText')
		} // captchaText
	}

	blurInput(dom) { // 让input失去焦点
		setTimeout(() => {
			this.refs[dom].blur()
		}, 20)
	}

	onBlurHandler = (target) => { // 失去焦点事件
		// let phoneNumber = this.state.phoneNumber
		setTimeout(() => {
			inputFocusScroll()
		}, 200)
	}

	onFocusHandler(target) { // 获取焦点事件
		if (target === 'phoneNumber') {
			let phoneNumber = this.state.phoneNumber
			this.setState({
				phoneNumber: cancelBlockPlace(phoneNumber)
			})
		}
	}

	isCountDown() { // 倒计时
		let seconds = parseInt(this.state.seconds)
		if (parseInt(seconds) > 0) {
			setTimeout(() => {
				this.lock && this.setState({
					seconds: seconds - 1
				}, this.isCountDown())
			}, 500)
		}
	}

	getGraphCode() { // 获取图形验证码
		// let timeString = Date.parse(new Date()).toString()
		// let key = timeString + timeString + '000000'
		let key = getMessageKey()
		this.setState({
			captchaInfo: {
				key: key,
				img: Api.getGraphCode + '?key=' + key
			},
			captchaText: ''
		})
	}

	showToast(el, message) { // 吐司
		showToast(message)
	}

	getMessageCode() { // 获取短信验证码
		let phoneNumer = cancelBlockPlace(this.state.phoneNumber)
		if (/^[1][3456789][0-9]{9}$/.test(phoneNumer)) {
			let {captchaText, captchaInfo} = this.state
			if (captchaInfo.key && (!captchaText || captchaText.length < 4)) {
				this.showToast(this, '请输入正确的图形验证码')
				return
			}
			/* 调用接口获取手机短信验证码 */
			getMsgCode({
				phoneNumber: phoneNumer,
				key: captchaInfo.key,
				validCode: captchaText
			}).then(res => {
				let data = res
				if (data.code === '9') { // 获取图形验证码
					this.getGraphCode()
				} else if (data.code === '2' || data.code === '403') {
					this.showToast(this, '请输入正确的图形验证码')
					this.getGraphCode()
				} else if (data.code === '1') {
					this.showToast(this, '操作过于频繁，请稍后再试')
				} else if (data.success || data.code === '0') { // 获取成功
					this.setState({
						seconds: 60
					}, () => setTimeout(() => {
						this.isCountDown() // 开启倒计时
					}, 200))
				} else {
					this.showToast(this, data.message)
				}
			}).catch(() => {
				this.showToast(this, '网络异常，请稍后重试')
			})
		} else {
			this.showToast(this, '请输入正确的手机号码')
		}
	}

	loginUser(e) { // 用户登录
		e.preventDefault()
		let {phoneNumber, messageCode, captchaText, captchaInfo} = this.state
		phoneNumber = cancelBlockPlace(phoneNumber)
		if (!/^[1][3456789][0-9]{9}$/.test(phoneNumber)) {
			this.showToast(this, '请输入正确的手机号码')
			return
		}
		if (captchaInfo.key && (!captchaText || captchaText.length < 4)) {
			this.showToast(this, '请输入正确的图形验证码')
			return
		}
		if (!messageCode || messageCode.length < 6) {
			this.showToast(this, '请输入正确的验证码')
			return
		}
		userLogin({
			smsValiCode: messageCode,
			mobile: phoneNumber
		}).then(res => {
			if (res.success) {
				let userInfo = {}
				userInfo.userId = res.valueObject.exjf.userId
				userInfo.token = res.valueObject.authToken
				userInfo.phoneNum = phoneNumber
				Config.loginInfo = userInfo
				loginBocUserInFzs()
				// this.$emit('hideLogin', 'refurbish')
				const _name = `userInfo${Config.channelId}`
				setStorageCache(_name, userInfo, true)
				successLogin()
			} else if (res.code === '503') { // 校验错误
				this.showToast(this, res.message)
			} else {
				this.showToast(this, '服务器异常,请稍后重试！')
			}
		}).catch(err => {
			console.log(err)
		})
	}

	testLogin() {
		// userInfoGDSFH_ZGYH{"userId":387198,"token":"8c8c15c49daedbd0b47e8cd141cd4d82","phoneNum":"13631923739"}
		const userInfo = {"userId":390648,"token":"9fa673a8e4459c9a84c4809b458ffd16","phoneNum":"13560436005"}
		Config.loginInfo = userInfo
		const _name = `userInfo${Config.channelId}`
		setStorageCache(_name, userInfo, true)
		successLogin()
	}

	close = () => {
		hideLogin()
	}

	imgLoad = (e) => {
		let name = e.target.name
		this.setState({
			[name]: true
		})
	}

	render() {
		const loginBg = require('../../asstes/img/alert/login.png')
		const loginClose = require('../../asstes/img/alert/login-close.png')
		const loginBtn = require('../../asstes/img/alert/login-btn.png')
		const {imgBgLoad, imgTop, phoneNumber, messageCode, captchaInfo, captchaText, seconds, selectMouseIdx} = this.state
		let isDiabled = 'disabled'
		const isPhone = cancelBlockPlace(phoneNumber).length === 11
			&& /^[1][3456789][0-9]{9}$/.test(cancelBlockPlace(phoneNumber))
		const isPhoneCode = messageCode.length === 6
		const isPicCode = !captchaInfo.img ? true : captchaText.length === 4
		if (isPhone && isPhoneCode && isPicCode) { // 规则都通过
			isDiabled = ''
		}
		const loginTopArr = [
			require('../../asstes/img/Index/gift-list/login-top1.png'),
			require('../../asstes/img/Index/gift-list/login-top2.png'),
			require('../../asstes/img/Index/gift-list/login-top3.png'),
			require('../../asstes/img/Index/gift-list/login-top4.png'),
			require('../../asstes/img/Index/gift-list/login-top5.png'),
			require('../../asstes/img/Index/gift-list/login-top6.png'),
		]

		0 && console.log((isDiabled));

		return <div className="login-container">
			<p className="prompt"></p>
			<div className="login-relative">
				<img className="login-top-img" name={'imgBgLoad'} onLoad={this.imgLoad} src={loginBg} alt=""/>
				{
					imgBgLoad ?
						<>
							<div className="login-container-content">
								<img src={loginTopArr[selectMouseIdx]} name={'imgTop'} onLoad={this.imgLoad} alt=""/>
								{
									imgTop ?
										<>
											<div className="login-top-text">
												{/*本活动受邀用户支付<span style={{color: '#fff'}}>1分钱</span>还有惊喜大奖，赶紧输入中国银行手机银行预留手机号码登录参与活动吧！*/}
												验证手机号，离惊喜红包更近一步哦
											</div>
											<div>
												{/* 手机号码 */}
												<div className="login-input-container">
													<div className="left-part">
														手机号码
													</div>
													<div className="right-input">
														<input type="tel" maxLength="11" placeholder={'手机号码'}
														       name={'phoneNumber'} ref={'phoneNumber'} value={phoneNumber}
														       onFocus={() => this.onFocusHandler('phoneNumber')}
														       onBlur={() => this.onBlurHandler('phoneNumber')}
														       onChange={this.handleInputChange}
														/>
													</div>
												</div>
												{/* 图形码 */}
												{
													captchaInfo.img ?
														<div className="login-input-container">
															<div className="left-part">
																图形码
															</div>
															<div className="right-input">
																<input type="text" maxLength="4" placeholder={'图形码'}
																       name={'captchaText'} ref={'captchaText'} value={captchaText}
																       onFocus={() => this.onFocusHandler('captchaText')}
																       onBlur={() => this.onBlurHandler('captchaText')}
																       onChange={this.handleInputChange}
																/>
																<p className="get-msg-img flex-center-center" onClick={() => this.getGraphCode()}>
																	<img src={captchaInfo.img} alt=""/>
																</p>
															</div>
														</div> : null
												}
												{/* 短信验证码 */}
												<div className="login-input-container">
													<div className="left-part">
														验证码
													</div>
													<div className="right-input">
														<input type="tel" maxLength="6" placeholder={'验证码'}
														       name={'messageCode'} ref={'messageCode'} value={messageCode}
														       onFocus={() => this.onFocusHandler('messageCode')}
														       onBlur={() => this.onBlurHandler('messageCode')}
														       onChange={this.handleInputChange}
														/>
														{
															seconds === 0 ?
																<p className="get-msg-code flex-center-center" onClick={() => this.getMessageCode()}>
																	<span>立即获取</span>
																</p> :
																<p className="get-msg-code flex-center-center">
																	<span>{seconds}S后重试</span>
																</p>
														}
													</div>
												</div>
											</div>
											<a href="/" onClick={(e) => this.loginUser(e)}>
												<img className="login-btn" src={loginBtn} alt=""/>
											</a>
											{/*<div className="flex-center-center">
												<button onClick={() => this.testLogin()}>test-login</button>
											</div>*/}
										</> : null
								}
							</div>
							<div className="login-close flex-center-center">
								<img className="login-close-icon" onClick={this.close} src={loginClose} alt=""/>
							</div>
						</> : null
				}
			</div>
		</div>
	}
}

export default Login;
